export default "__VITE_ASSET__b25d56f2__"